import { useEffect, useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import { HiSparkles } from 'react-icons/hi2';
import api from '../api';

export default function AISidebar({ open, onClose }) {
  const [iframeSrc, setIframeSrc] = useState(null);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  useEffect(() => {
    if (!open) { setIframeSrc(null); return; }
    api.createOidcSession()
      .finally(() => { setIframeSrc('https://ai.marvyitservices.com'); });
  }, [open]);

  if (!open) return null;

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-30 z-40" onClick={onClose} />
      <div className="fixed top-0 right-0 h-full w-[480px] max-w-full bg-white shadow-2xl z-50 flex flex-col">
        <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200 bg-[#0c1b4d] flex-shrink-0">
          <div className="flex items-center gap-2 text-white">
            <HiSparkles size={15} />
            <span className="text-sm font-semibold">Marvy AI</span>
          </div>
          <button onClick={onClose} className="text-white hover:text-gray-300 transition-colors p-1">
            <FaTimes size={15} />
          </button>
        </div>
        {iframeSrc ? (
          <iframe
            src={iframeSrc}
            className="flex-1 w-full border-0"
            title="Marvy AI"
            allow="clipboard-write; microphone"
          />
        ) : (
          <div className="flex-1 flex items-center justify-center text-gray-400 text-sm">
            Connecting...
          </div>
        )}
      </div>
    </>
  );
}
